module.exports = new __parcel__URL__("pear.c8d37fb0.svg").toString();